import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { RECAPTCHA_FG2 } from 'src/app/constantes/geral.constantes';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoRecaptchaService extends FgiBackEndService<any> {

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'public/front/recaptcha';
  } 

  obterChavePublicaCaptcha(): Observable<string> {
    return this.http.get(`${this.BASE_URL}/chave-publica`,
    {responseType: 'text'}) as Observable<string>;
  }

  validarCaptcha(responseToken: string): Observable<string> {

     localStorage.setItem(RECAPTCHA_FG2, responseToken);
    
    return this.http.get(`${this.BASE_URL}/${responseToken}/validar`,
    {responseType: 'text'}) as Observable<string>;
  }
}